import React,{ useEffect} from "react";
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import Home from "../pages/Home";
import Auth from "../pages/Auth";
import Login from "../pages/Login";
import MailingRules from "../pages/mailing-rules/MailingRules";
import Reporting from "../pages/mails/Reporting";
import Products from "../pages/products/Products";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { MailingRuleDetails } from "../pages/mailing-rules/MailingRuleDetails";
import MailingRuleCreate from "../pages/mailing-rules/MailingRuleCreate";
import { Templates } from "../pages/templates/Templates";
import { Documents } from "../pages/documents/Documents";
import DocumentEdit from "../pages/documents/DocumentEdit";
import { Mails } from "../pages/mails/Mails";
import { Healthcheck } from "../pages/Healthcheck/Healthcheck";
import PostLoginError from "../pages/PostLoginError";
import DocumentCreate from "../pages/documents/DocumentCreate";
import TemplateCreate from "../pages/templates/TemplateCreate";
import TemplateDetails from "../pages/templates/TemplateDetails";
import { Media } from "../pages/media/Media";
import { MediaCreate } from "../pages/media/MediaCreate";
import { MailingRuleEdit } from "../pages/mailing-rules/MailingRuleEdit";
import DocumentEditSection from "../components/pages/documents/edit/DocumentEditSection";

/**
 * MainRouter component, contains all the routes of the application
 * can include other routers
 * 
 * @returns {JSX.Element} MainRouter component
 */
function MainRouter() {

    const AUTHORIZED_GROUP_ID:string[] = [];

    const isAuthenticated = useIsAuthenticated();
    const {instance} = useMsal();

    const isAuthorized = ()=>{
        if (AUTHORIZED_GROUP_ID.length === 0) {
            return true;
        }

        const idTokenClaims = instance.getActiveAccount()?.idTokenClaims;
        if (idTokenClaims !== undefined && idTokenClaims.groups) {
            const groups:[] = idTokenClaims.groups as [];

            if (groups === undefined && groups === null) {
                return false;
            }

            return groups.some((group) => AUTHORIZED_GROUP_ID.includes(group));
        }
        return false;
    }

    useEffect(() => {
        if(instance.getActiveAccount() === null) {
            const account = instance.getAllAccounts()[0];
            if (account) {
                instance.setActiveAccount(account);
            }
        }
    }, [instance]);

    return (
        <>
            <Router>
                <Routes>
                    {!isAuthenticated && (
                        <Route path="/Login" element={<Login />}/>
                    )}

                    {(isAuthenticated && isAuthorized()) && (
                        <>
                            <Route path="/mailing-rules" element={<MailingRules />} />
                            <Route path="/mailing-rules/:uuid" element={<MailingRuleDetails />} />
                            <Route path="/mailing-rules/:uuid/edit" element={<MailingRuleEdit/>} />
                            <Route path="/mailing-rules/new" element={<MailingRuleCreate/>} />
                            <Route path="/products" element={<Products/>} />
                            <Route path="/templates" element={<Templates/>} />
                            <Route path="/templates/:uuid" element={<TemplateDetails/>} />
                            <Route path="/templates/new" element={<TemplateCreate/>} />
                            <Route path="/media" element={<Media />} />
                            <Route path="/media/new" element={<MediaCreate />} />
                            <Route path="/documents" element={<Documents/>} />
                            <Route path="/documents/:uuid/edit" element={<DocumentEdit/>} />
                            <Route path="/documents/new" element={<DocumentCreate/>} />
                            <Route path="/mails" element={<Mails/>}/>
                            <Route path="/healthcheck" element={<Healthcheck/>} />
                            <Route path="/reporting" element={<Reporting />} />
                        </>
                    )}

                    {(isAuthenticated && !isAuthorized()) && (
                        <Route index path="/*" element={<PostLoginError />} />
                    )}

                    <Route path="/auth" element={<Auth />} />
                    <Route index path="/*" element={<Home />} />
                </Routes>
            </Router>
        </>
    );
}

export default MainRouter;